import { z } from "zod";

import { Codelist } from "@/data/codelists";

export const LifecycleActionPerformed = z.union([
  z.literal("APPROVE"),
  z.literal("CREATE"),
  z.literal("REJECT"),
  z.literal("REVISE"),
  z.literal("SUBMIT"),
  z.literal("UPDATE"),
  z.literal("INTERVIEW"),
  z.literal("ACCEPT"),
  z.literal("WITHDRAW"),
  z.literal("EXPIRE"),
  z.literal("PRESENT"),
  z.literal("REOPEN"),
]);

export type LifecycleActionPerformed = z.infer<typeof LifecycleActionPerformed>;

export const LifecycleActionPerformedCodelist = Codelist<LifecycleActionPerformed>(LifecycleActionPerformed);

export type LifecycleActionPerformedCodelist = z.infer<typeof LifecycleActionPerformedCodelist>;
